import React, { FC } from 'react'
import './referral-card.css'

// COMPONENTS
import * as Icons from '@icons'

// UTILITIES
import { priceFormatter } from '@utils/number-helper'
import { flatten } from '@utils/string-helper'


export type ReferralCardVariant = 'creditAmount' | 'promo' | 'signUpClaim'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    variant: ReferralCardVariant
    creditAmount?: number
    promoAmount?: number
    onPillClick?: () => void
}

const ReferralCard: FC<Props> = (props) => {
    const { className: classProps, variant, creditAmount = 0, promoAmount = 500, onPillClick, onClick, onKeyDown, ...divProps } = props
    const className = flatten(
        'referral-card',
        variant === 'promo' ? 'promo' : variant === 'signUpClaim' ? 'sign-up-claim' : 'credit-amount',
        onClick ? 'clickable' : '',
        classProps
    )

    function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
        if (!onClick) return
        onKeyDown?.(event)
        if (event.defaultPrevented) return

        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            event.currentTarget.click()
        }
    }

    return (
        <div className={className} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} onClick={onClick} onKeyDown={handleKeyDown} {...divProps}>
            {(variant === 'promo' && onPillClick) ? (
                <button
                    type='button'
                    className='referral-card-pill referral-card-pill-button'
                    onClick={(event) => {
                        event.stopPropagation()
                        onPillClick()
                    }}
                >
                    START A GROUP
                </button>
            ) : (
                <div className='referral-card-pill'>
                    {variant === 'promo'
                        ? 'START A GROUP'
                        : variant === 'signUpClaim'
                            ? '$5 PROMO'
                            : 'REFERRAL PROGRAM'
                    }
                </div>
            )}
            {(variant === 'promo' || variant === 'signUpClaim') ? (
                <div className='referral-card-icon'>
                    <Icons.GiftBox width='2.5rem' height='2.5rem' tint='var(--splitcard-white)' />
                </div>
            ) : (
                <div className='referral-card-credits'>
                    <p className='referral-card-credits-label'>YOUR CREDITS</p>
                    <p className='referral-card-credits-value'>{priceFormatter.format(creditAmount / 100)}</p>
                </div>
            )}
            <div className='referral-card-content'>
                {(variant === 'promo') ? (
                    <h2 className='referral-card-title'>Earn <span className='highlight'>{priceFormatter.format(promoAmount / 100)}</span> in credits.</h2>
                ) : (variant === 'signUpClaim') ? (
                    <h3 className='referral-card-title'>Sign Up &amp; Claim <span className='highlight'>$5</span></h3>
                ) : (
                    <h2 className='referral-card-title'>Refer &amp; Earn <span className='highlight'>$5</span></h2>
                )}
                <p className='referral-card-description'>
                    {variant === 'promo'
                        ? 'Complete your first group goals to unlock it.'
                        : variant === 'signUpClaim'
                            ? 'Create an account and apply to your first group'
                            : 'Get rewarded for every friend you invite.'
                    }
                </p>
                {(variant === 'signUpClaim') && (
                    <div className='referral-card-credits-inline'>
                        <p className='referral-card-credits-inline-label'>Credits:</p>
                        <p className='referral-card-credits-inline-value'>{priceFormatter.format(promoAmount / 100)}</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ReferralCard
